module.exports = __webpack_public_path__ + "static/img/7.cd12f879.jpg";